import { render, staticRenderFns } from "./Restore.vue?vue&type=template&id=fe5652b4&scoped=true&lang=pug&"
import script from "./Restore.vue?vue&type=script&lang=ts&"
export * from "./Restore.vue?vue&type=script&lang=ts&"
import style0 from "./Restore.vue?vue&type=style&index=0&id=fe5652b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5652b4",
  null
  
)

export default component.exports